import { render, staticRenderFns } from "./UserDetailsComponent.vue?vue&type=template&id=e6a521ac&"
import script from "./UserDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./UserDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports